import { CreateCustomerMutation, CustomerCreateInput, Mutation } from '@vue-storefront/magento-types';
import { DeepPartial } from 'ts-essentials';
import { FetchResult } from '@apollo/client';
import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client } from '../../client';
import { CustomQuery, MethodOptions } from '../../types';

export async function createTeamMember(
  token: string,
  params: CustomerCreateInput,
  options?: MethodOptions<CustomQuery<'createTeamMember'>>,
) {
  return new AxiosRequestSender(client)
    .setUrl('createTeamMember')
    .setMethod('POST')
    .setProps([{token: token, input: params}])
    .setConfig(options?.clientConfig)
    .send();
}
